import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'self-filer-section',
  templateUrl: './self-filer-section.component.html',
  styleUrls: ['./self-filer-section.component.scss'],
})
export class SelfFilerSectionComponent implements OnInit {
  @Input() public header: string;
  @Input() public description: string;

  constructor() {}

  public ngOnInit(): void {}
}
